export default function unique<T = unknown>(values: T[]) {
    return Array.from(new Set(values));
}
